import { render, staticRenderFns } from "./Journal.vue?vue&type=template&id=d9208680&scoped=true&"
import script from "./Journal.vue?vue&type=script&lang=js&"
export * from "./Journal.vue?vue&type=script&lang=js&"
import style0 from "./Journal.vue?vue&type=style&index=0&id=d9208680&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9208680",
  null
  
)

export default component.exports